import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import vxmaestroEndpoints from '../../environments/endpoints/vxmaestro-endpoints';
import { environment } from '../../environments/environment';
import { Fund } from '../models/vxmaestro/funds';

@Injectable()
export class VxMaestroService {
  constructor(protected http: HttpClient) {}

  getFunds(): Observable<Fund[]> {
    const url = `${environment.apiCadastroSettings.url}/${vxmaestroEndpoints.getFunds}`;

    return this.http.get<Fund[]>(url);
  }
}
